import { Table } from "@mantine/core";
import { useCsvContext } from "../context/CsvContext";

export interface DataRow {
  angle: string;
  value: string | number;
}

export const DataTable = () => {
  const { csvData } = useCsvContext();

  const degrees = csvData[0]?.slice(1);
  const values = csvData[1]?.slice(1);

  const rows = degrees?.map((degree, index) => ({
    angle: degree,
    value: values[index],
  }));

  return (
    <div
      style={{
        maxHeight: "50rem",
        overflowY: "auto",
        borderRadius: "5px",
      }}
    >
      <Table striped highlightOnHover withBorder withColumnBorders>
        <thead>
          <tr>
            <th>각도</th>
            <th>값</th>
          </tr>
        </thead>
        <tbody>
          {!rows ? (
            <tr>
              <td colSpan={2} align="center">
                {"데이터가 없습니다."}
              </td>
            </tr>
          ) : (
            rows?.map((row, index) => (
              <tr key={index}>
                <td>{row.angle}</td>
                <td align="right">{row.value}</td>
              </tr>
            ))
          )}
        </tbody>
      </Table>
    </div>
  );
};
